export const breadcrumbConfig = [
  {
    path: "/admin/ai-model",
    crumbs: [
      { label: "Administration", navigable: false },
      { label: "Ai_model_title", navigable: false }
    ]
  },
  {
    path: "/admin/ai-model/runs/:run_id",
    crumbs: [
      { label: "Administration", navigable: false },
      { label: "Ai_model_title", navigable: true, toPattern: "/admin/ai-model" },
      { label: "Ai_model_run_title", navigable: false }
    ]
  },
  {
    path: "/admin/ai-model/versions/:model_version_id",
    crumbs: [
      { label: "Administration", navigable: false },
      { label: "Ai_model_title", navigable: true, toPattern: "/admin/ai-model" },
      { label: "Ai_model_version_title", navigable: false }
    ]
  },
  {
    path: "/admin/ai-model/training-data",
    crumbs: [
      { label: "Administration", navigable: false },
      { label: "Ai_model_title", navigable: true, toPattern: "/admin/ai-model" },
      { label: "Ai_model_training_data_title", navigable: false }
    ]
  },
  {
    path: "/admin/users",
    crumbs: [
      { label: "Administration", navigable: false },
      { label: "Users_title", navigable: false }
    ]
  },
  {
    path: "/admin/users/:user_id",
    crumbs: [
      { label: "Administration", navigable: false },
      { label: "Users_title", navigable: false }
    ]
  },
  {
    path: "/observations/view/:specialist",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "View", navigable: false },
      { label: ":specialist", navigable: false }
    ]
  },
  {
    path: "/observations/view/:specialist/:upload_id",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "View", navigable: false },
      { label: ":specialist", navigable: true, toPattern: "/observations/view/:specialist" },
      { label: "Observation", navigable: false }
    ]
  },
  {
    path: "/observations/analyse/:specialist/batch",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "Analyse", navigable: false },
      { label: ":specialist", navigable: true, toPattern: "/observations/view/:specialist" },
      { label: "Batch_analysis_title", navigable: false }
    ]
  },
  {
    path: "/observations/analyse/:specialist/:id/:upload_id",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "Analyse", navigable: false },
      { label: ":specialist", navigable: true, toPattern: "/observations/view/:specialist" },
      { label: "Prediction", navigable: false }
    ]
  },
  {
    path: "/observations/upload/:specialist",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "Upload", navigable: false },
      { label: ":specialist", navigable: false }
    ]
  },
  {
    path: "/observations/upload/:specialist/:upload_id",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "Upload", navigable: false },
      { label: ":specialist", navigable: true, toPattern: "/observations/upload/:specialist" },
      { label: "Observation", navigable: false }
    ]
  },
  {
    path: "/observations/edit/:specialist/:upload_id",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "Edit", navigable: false },
      { label: ":specialist", navigable: false },
      { label: "Observation", navigable: false }
    ]
  },
  {
    path: "/observations/upload/:specialist/add_tank",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "Upload", navigable: false },
      { label: ":specialist", navigable: true, toPattern: "/observations/upload/:specialist" },
      { label: "Add tank", navigable: false }
    ]
  },
  {
    path: "/observations/upload/:specialist/edit_tank/:tank_id",
    crumbs: [
      { label: "Observations", navigable: false },
      { label: "Upload", navigable: false },
      { label: ":specialist", navigable: true, toPattern: "/observations/upload/:specialist" },
      { label: "Edit tank", navigable: false }
    ]
  },
  // `keepSearch`: de filters van de catalogus staan in de zoekreeks; terug naar de catalogus hoort
  // ze mee te nemen, anders begin je na elke soort opnieuw met kiezen.
  { path: "/catalog/:species_id", crumbs: [{ label: "Catalog", navigable: true, toPattern: "/catalog", keepSearch: true }, { label: ":species_id", navigable: false }] },
  { path: "/catalog", crumbs: [{ label: "Catalog", navigable: false }] },
  { path: "/about", crumbs: [{ label: "About_us", navigable: false }] },
  { path: "/account", crumbs: [{ label: "Account", navigable: false }] },
  { path: "/dive-deep", crumbs: [{ label: "Dive_deep", navigable: false }] },
  {
    path: "/partners/:specialist",
    crumbs: [
      { label: "Partners", navigable: false },
      { label: ":specialist", navigable: false }
    ]
  },
  { path: "/what-we-do", crumbs: [{ label: "What_we_do", navigable: false }] }
]